import { EventContentArg } from '@fullcalendar/react';
import * as React from 'react';

function WeekView (eventInfo: EventContentArg) {
    const { event } = eventInfo;
    const { extendedProps, title } = event || {};
    const { categories, location, eventCategoryColor } = extendedProps || {};
    return (<>
        <div title={title + (location ? " @ " + location : "") + (categories ? " - " + categories : "")}
            className="short-event-text">
            <span className="fc-list-event-dot" style={{ borderColor: eventCategoryColor }}></span> &nbsp; {title}
        </div>
    </>);
}

export default WeekView;